"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.parse-int.js");
const lodash = {
  extend: (obj, obj2) => Object.assign(obj, obj2),
  isEmpty: arr => !arr.length,
  isEqual: (x, y) => JSON.stringify(x) === JSON.stringify(y),
  debounce: (func, delay) => {
    let inDebounce;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
  },
  after: (n, func) => {
    if (typeof func != "function") {
      throw new TypeError("FUNC_ERROR_TEXT");
    }
    n = parseInt(n);
    return function () {
      if (--n < 1) {
        return func.apply(this, arguments);
      }
    };
  },
  throttle: (func, wait, options) => {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function later() {
      previous = options.leading === false ? 0 : Date.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function () {
      var now = Date.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  }
};
module.exports = lodash;